;(function () {
  'use strict'

  angular.module('contrast.vulnerabilities').constant('VULN_REQUEST_EVENTS', {
    HIDE_TAB: 'hide.httprequest.tab'
  })
})()
